import { RouteRecordRaw } from 'vue-router'

const PARENT_VIEW = () => import('@/layout/routerView.vue')

const routes: RouteRecordRaw[] = [
  {
    path: 'resources',
    name: 'resources',
    component: PARENT_VIEW,
    redirect: '/resources/statistic',
    meta: { title: '人力资源管理', icon: 'svg:menu-hr', order: 100 },
    children: [
      { path: 'statistic', name: 'resources_statistic', component: () => import('@/views/Resource/Statistic/index.vue'), meta: { title: '人力资源统计', order: 10 } },
      {
        path: 'admin',
        name: 'resources_admin',
        component: PARENT_VIEW,
        redirect: '/resources/admin/elevate',
        meta: { title: '行政专员考核', order: 20 },
        children: [
          { path: 'elevate', name: 'resources_admin_elevate', component: () => import('@/views/Resource/Elevate/Admin/index.vue'), meta: { title: '考核列表' } },
          { path: 'import', name: 'resources_admin_import', component: () => import('@/views/Resource/Elevate/Admin/import.vue'), meta: { title: '考核导入', hidden: true } },
          { path: 'rank', name: 'resources_admin_rank', component: () => import('@/views/Resource/Elevate/Admin/rank.vue'), meta: { title: '考核排名' } },
          { path: 'config', name: 'resources_admin_config', component: () => import('@/views/Resource/Elevate/Admin/config.vue'), meta: { title: '考核标准' } },
          { path: 'category', name: 'resources_admin_category', component: () => import('@/views/Resource/Elevate/Admin/category.vue'), meta: { title: '考核内容分类', order: 50 } }
        ]
      },
      {
        path: 'tech',
        name: 'resources_tech',
        component: () => import('@/views/Resource/Elevate/Tech/index.vue'),
        meta: { title: '技术人员考核排名', order: 30 }
      }
    ]
  }
]

export default routes
